// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum ClientEndpointType {
	Json = 1,
	Email = 2,
	Luxcom = 3,
	MS2 = 4,
	WebRelay = 5,
	NTCIP_DMS = 6,
	Drakewell = 7,
	Fabric = 8,
}

export const ClientEndpointTypeDisplayNames: { [key in keyof typeof ClientEndpointType]?: string} = {
	"Json": "Json",
	1 : "Json",
	"Email": "Email",
	2 : "Email",
	"Luxcom": "Luxcom",
	3 : "Luxcom",
	"MS2": "MS2",
	4 : "MS2",
	"WebRelay": "WebRelay",
	5 : "WebRelay",
	"NTCIP_DMS": "NTCIP_DMS",
	6 : "NTCIP_DMS",
	"Drakewell": "Drakewell",
	7 : "Drakewell",
	"Fabric": "Fabric",
	8 : "Fabric",
}

export const getClientEndpointTypeDisplayName = (key: ClientEndpointType | (keyof typeof ClientEndpointType & string)) => {
	return ClientEndpointTypeDisplayNames[key];
}

